'use strict';

angular.module('lmsApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('school', {
                parent: 'entity',
                url: '/school',
                data: {
                    roles: ['OP_VIEW_SCHOOL','OP_MANAGE_SCHOOL'],
                    pageTitle: 'lmsApp.school.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/school/schools.html',
                        controller: 'SchoolController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('school');
                        return $translate.refresh();
                    }]
                }
            })
            .state('schoolDetail', {
                parent: 'entity',
                url: '/school/:id',
                data: {
                    roles: ['OP_VIEW_SCHOOL','OP_MANAGE_SCHOOL'],
                    pageTitle: 'lmsApp.school.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/school/school-detail.html',
                        controller: 'SchoolDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('school');
                        return $translate.refresh();
                    }]
                }
            });
    });
